import React from 'react';
import cx from 'classnames';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckIcon from '@mui/icons-material/Check';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import SunnyIcon from '@mui/icons-material/Sunny';
import styles from '@/common/containers/UserIntro/styles.less';
import { Trans, useTranslation } from 'react-i18next';
import CopyrightSup from '@/common/components/CopyrightSup';
import { Typography } from '@mui/material';

const RegisteredSup = () => <sup className="copyrightSup">®</sup>;

const Second = () => {
  const { t } = useTranslation();
  const copyrightSup = <CopyrightSup />;
  const registeredSup = <RegisteredSup />;

  const steps = [
    {
      number: '01',
      title: t('Tell us about the situation'),
      text: (
        <Trans
          i18nKey="PAEM After Care<copyrightSup/> uses questionnaires to collect the required information about the decedent’s unique situation."
          components={{ copyrightSup }}
        />
      ),
    },
    {
      number: '02',
      title: t('Get your comprehensive plan'),
      text: (
        <Trans
          i18nKey="Based on your responses, PAEM After Care<copyrightSup/> generates a complete list of tasks in the recommended order of priority."
          components={{ copyrightSup }}
        />
      ),
    },
    {
      number: '03',
      title: t('Follow step-by-step guidance'),
      text: t(
        'Each task includes clear instructions, with progress tracked through to completion.'
      ),
    },
  ];

  const benefits = [
    {
      Icon: SunnyIcon,
      title: t('Personalization'),
      text: (
        <Trans
          i18nKey="Ensures tasks are tailored to the decedent’s specific PAEM<copyrightSup/> requirements, focusing only on what is relevant."
          components={{ copyrightSup }}
        />
      ),
    },
    {
      Icon: CheckIcon,
      title: t('Confidence'),
      text: t(
        'Ensures all required tasks are identified, clearly organised, and tracked, so you can proceed with confidence.'
      ),
    },
    {
      Icon: StickyNote2Icon,
      title: t('Reassurance'),
      text: (
        <Trans
          i18nKey="Confirms the decedent’s PAEM<registeredSup/> requirements are being managed effectively, correctly, and, that things are under control."
          components={{ registeredSup }}
        />
      ),
    },
  ];

  return (
    <div className={cx(styles.screen, styles.second)}>
      <div className={styles.secondContent}>
        <Typography variant="h2">{t('How it works')}</Typography>
        <div className={styles.secondSteps}>
          {steps.map(({ number, title, text }, index) => (
            <React.Fragment key={number}>
              <div className={styles.secondStep}>
                <div className={styles.secondStepNumber}>{number}</div>
                <Typography variant="h4" className={styles.secondStepTitle}>{title}</Typography>
                <Typography variant="body1" sx={{ mt: 3 }}>{text}</Typography>
              </div>
              {index < steps.length - 1 && (
                <ArrowForwardIcon sx={{ fontSize: 32 }} className={styles.secondStepArrow} />
              )}
            </React.Fragment>
          ))}
        </div>
        <Typography variant="h2">{t('What you get')}</Typography>
        <div className={styles.secondBenefits}>
          {benefits.map(({ Icon, title, text }) => (
            <div className={styles.secondBenefit} key={title}>
              <Icon className={styles.secondBenefitIcon} sx={{ fontSize: 32 }} />
              <Typography variant="h5" sx={{ mt: 4, mb: 2 }} color="#2E946D">{title}</Typography>
              <Typography variant="body1" color="#000000">{text}</Typography>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Second;
